import React, { Component } from 'react';
//import PropTypes from 'prop-types';
//import './btns.scss';
import GeckoBtns from './btns.jsx';
import { GeckoBtnsModel } from '../../models';

class GeckoBtnsSorted extends Component {
  getPrimaryButtons() {
    return this.props.items.filter(
      (btn) => btn.primary || (!btn.primary && !btn.secondary)
    );
  }

  getSecondaryButtons() {
    return this.props.items.filter((btn) => btn.secondary);
  }

  renderPrimaryBtns() {
    const primaryBtns = this.getPrimaryButtons();
    if (primaryBtns.length) {
      return (
        <div className="pull-right">
          <GeckoBtns items={primaryBtns} />
        </div>
      );
    }
    return null;
  }

  renderSecondaryBtns() {
    const secondaryBtns = this.getSecondaryButtons();
    if (secondaryBtns.length) {
      return (
        <div className="pull-left">
          <GeckoBtns items={secondaryBtns} />
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="clearfix">
        {this.renderPrimaryBtns()}
        {this.renderSecondaryBtns()}
      </div>
    );
  }
}

GeckoBtnsSorted.defaultProps = {
  items: [],
  //group: false
};

GeckoBtnsSorted.propTypes = {
  items: GeckoBtnsModel,
  //group: PropTypes.bool
};

export default GeckoBtnsSorted;
